import { render, staticRenderFns } from "./DetalleEvento.vue?vue&type=template&id=43e28238&"
import script from "./DetalleEvento.vue?vue&type=script&lang=js&"
export * from "./DetalleEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports